import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppClassTabComponent } from './class.component';

const routes: Routes = [{ path: '', component: AppClassTabComponent }];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AppClassTabRoutingModule { }
